import { DrawerBodyWrapper, DrawerFooterWrapper } from '@base'

const EnhancementForm = () => {
	return (
		<>
			<DrawerBodyWrapper></DrawerBodyWrapper>
			<DrawerFooterWrapper></DrawerFooterWrapper>
		</>
	)
}

export default EnhancementForm
